import React, { useState , useEffect} from 'react';
import { 
  Layout, 
  Typography, 
  Row, 
  Col, 
  Form, 
  Input, 
  Button, 
  message,
  Divider,
  Card,
  Avatar
} from 'antd';
import { 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined, 
  ClockCircleOutlined,
  UserOutlined,
  MessageOutlined 
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './ContactPage.css';
import emailjs from '@emailjs/browser';


const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;




const ContactPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  emailjs.init("LpGHjGFRi7Ux4CIIy"); // Initialize with your user ID
}, []);

  // const onFinish = async (values) => {
  //   setLoading(true);
  //   try {
  //     // Here you would typically make an API call to your backend
  //     console.log('Form values:', values);
  //     await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
  //     message.success('Your message has been sent successfully!');
  //     form.resetFields();
  //   } catch (error) {
  //     message.error('Failed to send message. Please try again later.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

const onFinish = async (values) => {
  setLoading(true);
  try {
    await emailjs.send(
      'service_q29g84f', 
      'template_drgckbt',
      values,
      'LpGHjGFRi7Ux4CIIy'
    );
    
    message.success('Your message has been sent successfully!');
    form.resetFields();
  } catch (error) {
    message.error('Failed to send message. Please try again later.');
    console.error('Error:', error);
  } finally {
    setLoading(false);
  }
};


  return (
    <Layout className="layout">
      <Header />
      <Content className="contact-content">
        {/* Hero Section */}
        <div className="contact-hero">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Title level={1} className="hero-title">Contact Us</Title>
            <Paragraph className="hero-text">
              Get in touch with our PHC accreditation experts for consultation and support.
            </Paragraph>
          </motion.div>
        </div>

        {/* Contact Form and Info */}
        <div className="contact-main-section">
          <Row gutter={[48, 48]}>
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Card className="contact-form-card" title="Send Us a Message">
                  <Form
                    form={form}
                    name="contact"
                    layout="vertical"
                    onFinish={onFinish}
                  >
                    <Form.Item
                      name="name"
                      label="Your Name"
                      rules={[{ required: true, message: 'Please input your name!' }]}
                    >
                      <Input prefix={<UserOutlined />} placeholder="John Doe" />
                    </Form.Item>

                    <Form.Item
                      name="email"
                      label="Email Address"
                      rules={[
                        { 
                          required: true, 
                          message: 'Please input your email!' 
                        },
                        { 
                          type: 'email', 
                          message: 'Please enter a valid email!' 
                        }
                      ]}
                    >
                      <Input prefix={<MailOutlined />} placeholder="john@example.com" />
                    </Form.Item>

                    <Form.Item
                      name="phone"
                      label="Phone Number"
                    >
                      <Input prefix={<PhoneOutlined />} placeholder="+92 300 1234567" />
                    </Form.Item>

                    <Form.Item
                      name="subject"
                      label="Subject"
                      rules={[{ required: true, message: 'Please input a subject!' }]}
                    >
                      <Input prefix={<MessageOutlined />} placeholder="Regarding PHC Accreditation" />
                    </Form.Item>

                    <Form.Item
                      name="message"
                      label="Your Message"
                      rules={[{ required: true, message: 'Please input your message!' }]}
                    >
                      <TextArea rows={6} placeholder="Type your message here..." />
                    </Form.Item>

                    <Form.Item>
                      <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                        <Button 
                          type="primary" 
                          htmlType="submit" 
                          loading={loading}
                          block
                          size="large"
                        >
                          Send Message
                        </Button>
                      </motion.div>
                    </Form.Item>
                  </Form>
                </Card>
              </motion.div>
            </Col>

            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Card className="contact-info-card" title="Contact Information">
                  <div className="contact-info-item">
                    <Avatar 
                      size={48} 
                      icon={<PhoneOutlined />} 
                      className="contact-info-icon phone-icon"
                    />
                    <div className="contact-info-content">
                      <Text strong className="contact-info-title">Phone</Text>
                      <Paragraph className="contact-info-text">
                        +92 300 6617550<br />
                      </Paragraph>
                    </div>
                  </div>

                  <Divider className="contact-info-divider" />

                  <div className="contact-info-item">
                    <Avatar 
                      size={48} 
                      icon={<MailOutlined />} 
                      className="contact-info-icon email-icon"
                    />
                    <div className="contact-info-content">
                      <Text strong className="contact-info-title">Email</Text>
                      <Paragraph className="contact-info-text">
                        primehealthcare.pk@gmail.com <br />
                      </Paragraph>
                    </div>
                  </div>

                  {/* <Divider className="contact-info-divider" /> */}

                  {/* <div className="contact-info-item">
                    <Avatar 
                      size={48} 
                      icon={<EnvironmentOutlined />} 
                      className="contact-info-icon address-icon"
                    />
                    <div className="contact-info-content">
                      <Text strong className="contact-info-title">Address</Text>
                      <Paragraph className="contact-info-text">
                        123 Healthcare Street<br />
                        Lahore, Punjab 54000<br />
                        Pakistan
                      </Paragraph>
                    </div>
                  </div> */}

                  <Divider className="contact-info-divider" />

                  <div className="contact-info-item">
                    <Avatar 
                      size={48} 
                      icon={<ClockCircleOutlined />} 
                      className="contact-info-icon hours-icon"
                    />
                    <div className="contact-info-content">
                      <Text strong className="contact-info-title">Working Hours</Text>
                      <Paragraph className="contact-info-text">
                        Monday - Friday: 9:00 AM - 5:00 PM<br />
                        Saturday: 10:00 AM - 2:00 PM<br />
                        Sunday: Closed
                      </Paragraph>
                    </div>
                  </div>
                </Card>

                
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <Title level={2} className="section-title">Frequently Asked Questions</Title>
          <Row gutter={[24, 24]} style={{ marginTop: 48 }}>
            <Col xs={24} md={12}>
              <Card className="faq-card" title="How long does PHC accreditation take?">
                <Paragraph>
                  The PHC accreditation process typically takes 6-12 months depending on your facility's 
                  current compliance level. Our consultants can help expedite the process through our 
                  proven methodology.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className="faq-card" title="What is your success rate for accreditation?">
                <Paragraph>
                  We maintain a 95% success rate for first-time accreditation when clients implement 
                  all our recommendations. For facilities that follow our complete guidance program, 
                  the success rate is 100%.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className="faq-card" title="Do you work with small clinics?">
                <Paragraph>
                  Yes, we work with healthcare facilities of all sizes, from small clinics to large 
                  hospitals. Our services are tailored to each client's specific needs and scale.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className="faq-card" title="What regions do you serve?">
                <Paragraph>
                  While we're based in Lahore, we serve healthcare facilities throughout Punjab. 
                  Our consultants are available to travel to your location as needed.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default ContactPage;